import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './OnlineQuranClassesInNewyork.css';
import { submitForm } from '../utils/formSubmit';
import Swal from 'sweetalert2';

const tutorsData = [
  {
    name: 'Qaria Sadaf Sarfaraz',
    role: 'Islamic Scholar',
    description: 'Highest satisfaction rate in first class most student',
    image: 'tutor-yousra.jpeg',
    profileUrl: '/our-tutors/qaria-sadaf-sarfaraz/'
  },
  {
    name: 'Molana Hafiz Qari Osama Hussein',
    role: 'Islamic scholar',
    description: 'Specialization in Islamic studies of Seeratun Nabi (S.A.W)',
    image: 'tutor-osama.jpg',
    profileUrl: '/our-tutors/molana-hafiz-qari-osama-hussein/'
  },
  {
    name: 'Molana Hafiz Kaleem Ullah',
    role: 'Islamic scholar',
    description: 'Specialization in Islamic studies of Seeratun Nabi (S.A.W)',
    image: 'tutor-kaleem.jpg',
    profileUrl: '/our-tutors/molana-hafiz-kaleem-ullah/'
  },
  {
    name: 'Aalima Qaria Yousra',
    role: 'Islamic Scholar',
    description: 'Highest satisfaction rate in first class most student',
    image: 'tutor-sadaf.jpeg',
    profileUrl: '/our-tutors/aalima-qaria-yousra/'
  }
];

const FloridaLeftFAQs = [
  {
    id: 'fl-left-0',
    question: 'Can I enroll my children in online Quran classes in Florida?',
    answer: 'Yes. We offer online Quran classes for children in Florida. Beginners can start with the Arabic alphabet and Noorani Qaida before progressing to Quran reading, recitation, and basic Tajweed.'
  },
  {
    id: 'fl-left-1',
    question: 'Are online Quran classes suitable for beginners?',
    answer: "Yes. Our classes are suitable for beginners of all ages, even if the student has never read Arabic before. Tutors start from the very basics and move forward at the student's own pace, so no prior experience is needed."
  },

];

const FloridaRightFAQs = [
  {
    id: 'fl-right-0',
    question: 'What is taught in Quran Tajweed classes?',
    answer: (<>
      In Tajweed classes, students learn Makharij (articulation points), proper pronunciation <a style={{ color: "#006100" }} href="/quran-tajweed-rules-guide-rules-for-reading-quran/">Tajweed rules,</a> and correct Quran recitation.
    </>)
  },
  {
    id: 'fl-right-1',
    question: 'Are the classes individual or in groups?',
    answer: "Yes, all our classes are one-on-one, so each student gets the tutor's undivided attention. Individual classes allow teachers to manage each lesson to the student's learning pace and individual needs."
  },
  {
    id: 'fl-left-2',
    question: 'Can adults enroll in your Quran classes?',
    answer: 'Yes. Adult students in Florida can enroll in online courses for Quranic reading, Tajweed, recitation, memorization, and Islamic studies.'
  },
  {
    id: 'fl-left-3',
    question: 'Do you provide male and female Quran tutors?',
    answer: "Yes. Both male and female Quran tutors are available for students in Florida. You can choose a male or female teacher based on your or your child's preference."
  },
];

const floridaSchema = {
  "@context": "https://schema.org",
  "@type": ["EducationalOrganization", "LocalBusiness"],
  "@id": "https://alquranlesson.com/florida-online-quran-classes/#localbusiness",
  "name": "Al Quran Lesson",
  "url": "https://alquranlesson.com/florida-online-quran-classes/",
  "logo": "https://alquranlesson.com/assets/images/logo.png",
  "image": "https://alquranlesson.com/assets/images/logo.png",
  "description": "Online Quran academy offering one-on-one online Quran classes in Florida with expert male and female tutors, flexible scheduling, 24/7 support, and a 3-day free trial.",
  "telephone": "+1-716-457-7657",
  "email": "info@alquranlesson.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "1942 Broadway St Ste 314C",
    "addressLocality": "Boulder",
    "addressRegion": "CO",
    "postalCode": "80302",
    "addressCountry": "US"
  },
  "areaServed": [
    { "@type": "State", "name": "Florida" },
    { "@type": "City", "name": "Miami" },
    { "@type": "City", "name": "Orlando" },
    { "@type": "City", "name": "Tampa" },
    { "@type": "City", "name": "Jacksonville" }
  ],
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    "opens": "00:00",
    "closes": "23:59"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Online Quran Courses in Florida",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Course",
          "name": "Noorani Qaida Course",
          "description": "A beginner course that teaches the Arabic alphabet, letter sounds, and basic reading rules through one-on-one online classes.",
          "provider": { "@type": "Organization", "name": "Al Quran Lesson", "url": "https://alquranlesson.com/" }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Course",
          "name": "Quran Reading Course",
          "description": "One-on-one online lessons that help students read the Quran fluently with correct pronunciation.",
          "provider": { "@type": "Organization", "name": "Al Quran Lesson", "url": "https://alquranlesson.com/" }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Course",
          "name": "Tajweed Course",
          "description": "One-on-one online Tajweed lessons covering Makharij, pronunciation, and Tajweed rules for correct Quran recitation.",
          "provider": { "@type": "Organization", "name": "Al Quran Lesson", "url": "https://alquranlesson.com/" }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Course",
          "name": "Hifz (Quran Memorization) Course",
          "description": "A structured one-on-one online Quran memorization program with regular revision and guidance from qualified tutors.",
          "provider": { "@type": "Organization", "name": "Al Quran Lesson", "url": "https://alquranlesson.com/" }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Course",
          "name": "Islamic Studies Course",
          "description": "Online Islamic studies lessons for children and adults, taught one-on-one by qualified tutors.",
          "provider": { "@type": "Organization", "name": "Al Quran Lesson", "url": "https://alquranlesson.com/" }
        }
      }
    ]
  },
  "sameAs": [
    "https://www.facebook.com/readingonlinequran",
    "https://www.instagram.com/alquranlessons/"
  ]
};

const floridaFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Can I enroll my children in online Quran classes in Florida?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. We offer online Quran classes for children in Florida. Beginners can start with the Arabic alphabet and Noorani Qaida before progressing to Quran reading, recitation, and basic Tajweed."
      }
    },
    {
      "@type": "Question",
      "name": "Are online Quran classes suitable for beginners?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Our classes are suitable for beginners of all ages, even if the student has never read Arabic before. Tutors start from the very basics and move forward at the student's own pace, so no prior experience is needed."
      }
    },
    {
      "@type": "Question",
      "name": "Can adults enroll in your Quran classes?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Adult students in Florida can enroll in online courses for Quranic reading, Tajweed, recitation, memorization, and Islamic studies."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide male and female Quran tutors?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Both male and female Quran tutors are available for students in Florida. You can choose a male or female teacher based on your or your child's preference."
      }
    },
    {
      "@type": "Question",
      "name": "What is taught in Quran Tajweed classes?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In Tajweed classes, students learn Makharij (articulation points), proper pronunciation, Tajweed rules, and correct Quran recitation."
      }
    },
    {
      "@type": "Question",
      "name": "Are the classes individual or in groups?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all our classes are one-on-one, so each student gets the tutor's undivided attention. Individual classes allow teachers to tailor each lesson to the student's learning pace and individual needs."
      }
    }
  ]
};

const OnlineQuranClassesFlorida = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });

  const [openFaqId, setOpenFaqId] = useState(null);

  const toggleFloridaFAQ = (id) => {
    setOpenFaqId(prevId => (prevId === id ? null : id));
  };

  const handleOpenChat = (e) => {
    if (e) e.preventDefault();
    if (window.Tawk_API) {
      if (typeof window.Tawk_API.showWidget === 'function') {
        window.Tawk_API.showWidget();
      }
      if (typeof window.Tawk_API.maximize === 'function') {
        window.Tawk_API.maximize();
        return;
      }
      if (typeof window.Tawk_API.toggle === 'function') {
        window.Tawk_API.toggle();
        return;
      }
    }
    window.open('https://embed.tawk.to/616f933686aee40a57376d67/1fidte3c3', '_blank');
  };

  const [assessmentData, setAssessmentData] = useState({
    firstName: '',
    lastName: '',
    course: 'Noorani Qaida',
    country: '',
    phone: '',
    message: ''
  });

  const handleAssessmentChange = (e) => {
    const { name, value } = e.target;
    setAssessmentData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAssessmentSubmit = async (e) => {
    e.preventDefault();
    if (!assessmentData.firstName || !assessmentData.lastName || !assessmentData.course || !assessmentData.country || assessmentData.country === 'Country' || !assessmentData.phone || !assessmentData.message) {
      Swal.fire({
        title: 'All Fields Required',
        text: 'Please fill in all fields including Country and Message.',
        icon: 'warning',
        confirmButtonColor: '#5c9456'
      });
      return;
    }
    try {
      await submitForm('Florida Assessment Form', assessmentData);
      Swal.fire({
        title: 'Success!',
        text: `Thank you, ${assessmentData.firstName}! Your free trial request has been submitted.`,
        icon: 'success',
        confirmButtonColor: '#5c9456'
      });
      setAssessmentData({
        firstName: '',
        lastName: '',
        course: 'Noorani Qaida',
        country: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#5c9456'
      });
    }
  };

  // Animated counters state
  const [experience, setExperience] = useState(0);
  const [students, setStudents] = useState(0);
  const [tutors, setTutors] = useState(0);

  // FAQ active state mapping (all closed by default)
  const [activeFaqs, setActiveFaqs] = useState({});

  const toggleFaq = (index) => {
    setActiveFaqs(prev => {
      const isOpen = prev[index];
      return isOpen ? {} : { [index]: true };
    });
  };

  // Testimonials Slider State
  const [currentSlide, setCurrentSlide] = useState(0);
  const testimonials = [
    {
      text: "I was concerned about my childâ€™s religious education, and now I am very pleased to see that they offer Quran classes in Florida. They have very nice and skilled tutors, and the ability to attend classes without disturbing school commitments was a huge bonus.",
      author: "Aisha - Miami"
    },
    {
      text: "I joined their online Quran with Tajweed classes in Florida. The teachers are professional, and the individual attention and support that I received during the Tajweed classes were excellent. The one-on-one lessons are very helpful to correct minor mistakes quickly.",
      author: "Yusuf - Orlando"
    },
    {
      text: "My children look forward to their classes and love to learn because of the knowledgeable and supportive Quran education their teachers provide. I highly recommend The Quran academy Florida for anyone looking for Quran teachers near me in Florida.",
      author: "Mariam - Tampa"
    },
    {
      text: "I was looking for Quran teachers near me in Florida, and then I enrolled there. From the free trial to regular classes, everything has been smooth. The tutors focus on real progress. One of the best platforms for online Quran classes for kids in Florida.",
      author: "Ibrahim - Jacksonville"
    }
  ];

  // Auto-play timer for testimonials (5 seconds)
  useEffect(() => {
    const slideTimer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(slideTimer);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };

  // Contact Form State
  const [contactData, setContactData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    country: '',
    course: '',
    message: '',
    consent: false
  });

  const handleContactChange = (e) => {
    const { name, value, type, checked } = e.target;
    setContactData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    if (!contactData.consent) {
      Swal.fire({
        title: 'Consent Required',
        text: "Please consent to terms to proceed.",
        icon: 'warning',
        confirmButtonColor: '#5c9456'
      });
      return;
    }
    try {
      await submitForm('Florida Contact Form', contactData);
      Swal.fire({
        title: 'Success!',
        text: `Thank you, ${contactData.firstName} ${contactData.lastName}! We have received your message.`,
        icon: 'success',
        confirmButtonColor: '#5c9456'
      });
      setContactData({
        firstName: '',
        lastName: '',
        phone: '',
        country: '',
        course: '',
        message: '',
        consent: false
      });
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#5c9456'
      });
    }
  };

  useEffect(() => {
    // Load Calendly widget script dynamically
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    // Load Google reCAPTCHA v2 API script dynamically if not already loaded
    const scriptId = 'google-recaptcha-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://www.google.com/recaptcha/api.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    // Experience counter (0 to 13)
    let expStart = 0;
    const expEnd = 13;
    const expDuration = 1200; // ms
    const expStepTime = Math.max(Math.floor(expDuration / expEnd), 15);
    const expTimer = setInterval(() => {
      expStart += 1;
      setExperience(expStart);
      if (expStart >= expEnd) {
        clearInterval(expTimer);
      }
    }, expStepTime);

    // Tutors counter (0 to 20)
    let tutorsStart = 0;
    const tutorsEnd = 20;
    const tutorsDuration = 1200; // ms
    const tutorsStep = 1;
    const tutorsStepTime = Math.max(Math.floor(tutorsDuration / (tutorsEnd / tutorsStep)), 15);
    const tutorsTimer = setInterval(() => {
      tutorsStart += tutorsStep;
      setTutors(tutorsStart);
      if (tutorsStart >= tutorsEnd) {
        clearInterval(tutorsTimer);
      }
    }, tutorsStepTime);

    // Students counter (0 to 5000)
    let studentsStart = 0;
    const studentsEnd = 5000;
    const studentsDuration = 1200; // ms
    const studentsStep = 100;
    const studentsStepTime = Math.max(Math.floor(studentsDuration / (studentsEnd / studentsStep)), 15);
    const studentsTimer = setInterval(() => {
      studentsStart += studentsStep;
      setStudents(studentsStart);
      if (studentsStart >= studentsEnd) {
        clearInterval(studentsTimer);
      }
    }, studentsStepTime);

    return () => {
      clearInterval(expTimer);
      clearInterval(tutorsTimer);
      clearInterval(studentsTimer);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitForm('Florida Registration Form', formData);
      Swal.fire({
        title: 'Success!',
        text: `Thank you, ${formData.name}! Your request has been sent successfully. We will contact you soon.`,
        icon: 'success',
        confirmButtonColor: '#5c9456'
      });
      setFormData({ name: '', phone: '', message: '' });
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#5c9456'
      });
    }
  };

  return (
    <div className="ny-page-wrapper">
      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(floridaSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(floridaFaqSchema) }}
      />

      {/* Hero Section */}
      <section
        className="ny-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-california/florida.jpg')`
        }}
      >
        <div className="ny-hero__container">
          {/* Left Column: Heading, description, and stats */}
          <div className="ny-hero__content">
            <h1 className="ny-hero__title">
              <span className="ny-hero__title--highlight" style={{ marginBottom: '8px' }}>Online Quran Classes in Florida:</span>
              <span className="ny-hero__title--main"> Your Trusted Online Quran Academy</span>
            </h1>
            <p className="ny-hero__desc">
              If you live in Florida and are looking for a Quran teacher for yourself or your child, Al Quran Lesson has a wide range of Quran courses that provide personalized, one-to-one online Quran classes with experienced teachers. Our online Quran academy has been teaching students since 2013, and our experienced teachers provide personalized attention to every student. Our online Quran classes are available for students of all ages, from children beginning with Noorani Qaida to adults who want to improve their Tajweed, recitation, or Quran memorization. Get a 3-day free trial and start learning Quran online from home in Florida.
            </p>

            {/* Stats list */}
            <div className="ny-hero__stats">
              <div className="ny-stat-item">
                <span className="ny-stat-value">{experience} +</span>
                <span className="ny-stat-label">Years Of Experience</span>
              </div>
              <div className="ny-stat-item">
                <span className="ny-stat-value">{students.toLocaleString()} +</span>
                <span className="ny-stat-label">Students Studied</span>
              </div>
              <div className="ny-stat-item">
                <span className="ny-stat-value">{tutors}+</span>
                <span className="ny-stat-label">Expert Tutors</span>
              </div>
            </div>
          </div>

          {/* Right Column: Sign Up Form Card */}
          <div className="ny-hero__form-card">
            <div className="ny-form-header">
              <h4 className="ny-form-title">Sign Up</h4>
              <h4 className="ny-form-subtitle">To Claim Your Free Trial</h4>
            </div>

            <form onSubmit={handleSubmit} className="ny-form">
              <div className="ny-form-row">
                <div className="ny-form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="ny-form-input"
                  />
                </div>
                <div className="ny-form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="ny-form-input"
                  />
                </div>
              </div>

              <div className="ny-form-group">
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="ny-form-textarea"
                />
              </div>

              {/* reCAPTCHA integration */}
              <div className="ny-recaptcha-container">
                <div
                  className="g-recaptcha"
                  data-sitekey={
                    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
                      ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' // Public Google test key for localhost development
                      : '6LdiHz4tAAAAAONg4UJVDRkG1K3enavhCUQbnmLx' // Production key for alquranlesson.com
                  }
                ></div>
              </div>

              <button type="submit" className="ny-form-submit-btn">
                Claim Free Trial
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Three Highlights Section */}
      <section className="ny-highlights-section">
        <div style={{ textAlign: "center", width: "100%" }}><h2 className="tx-reviews-title">Florida's Structured Online Quran <br /> Courses For Every Age Group</h2></div>
        <br />
        <div className="ny-highlights-container">
          {/* Card 1: Noorani Qaida */}
          <a href="/noorani-qaida-course/" className="ny-highlight-card" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="ny-highlight-icon-box" style={{ margin: '0 auto 20px auto' }}>
              <svg className="ny-highlight-icon-svg" viewBox="0 0 576 512" fill="currentColor">
                <path d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z" />
              </svg>
            </div>
            <h3 className="ny-highlight-title">Noorani Qaida Classes In Florida </h3>
            <p className="ny-highlight-desc">
              Our online classes for beginners are for students who have just started learning, either children or adults. First, we introduce Noorani Qaida, the Arabic alphabet, and its pronunciations. You shall be taught basic skills of reading the Quran by experts in our teaching faculty. Students from all over Florida can join our online classes from home.
            </p>
          </a>

          {/* Card 2: Tajweed Classes */}
          <a href="/online-tajweed-classes-tajweed-course/" className="ny-highlight-card" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="ny-highlight-icon-box" style={{ margin: '0 auto 20px auto' }}>
              <svg className="ny-highlight-icon-svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />
              </svg>
            </div>
            <h3 className="ny-highlight-title">Quran Tajweed Classes In Florida</h3>
            <p className="ny-highlight-desc">
              If you are looking to advance your tajweed skills of reciting the Quran, you will benefit from our online Tajweed classes for the Quran. In our online Quran classes in Florida, students, with enough practice and excellent teaching, attain great confidence and fluency in recitation.
            </p>
          </a>

          {/* Card 3: Quran Memorization */}
          <a href="/quran-memorization-classes-course/" className="ny-highlight-card" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="ny-highlight-icon-box" style={{ margin: '0 auto 20px auto' }}>
              <svg className="ny-highlight-icon-svg" viewBox="0 0 640 512" fill="currentColor">
                <path d="M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z" />
              </svg>
            </div>
            <h3 className="ny-highlight-title">Quran Memorization In Florida</h3>
            <p className="ny-highlight-desc">
              Our Quran Memorization with Tajweed classes are designed to help students memorize the Quran accurately while developing proper recitation skills. Students learn effective Hifz techniques, strengthen their memorization through regular practice, and improve their Tajweed for confident and fluent Quran recitation.
            </p>
          </a>
        </div>
      </section>

      <br />
      {/* Intro Info Section */}
      <section className="ny-intro-section">
        <div className="ny-intro-container">
          {/* Left Column: Text & CTA */}
          <div className="ny-intro-content">
            <h2 className="ny-intro-title">
              Online Quran Academy Serving
              <span className="ny-intro-title--green"> Florida and Nationwide
              </span>
            </h2>
            <p className="ny-intro-desc">
              Al Quran Lesson is an <a style={{ color: "#006100" }} href="/">online Quran academy</a> serving students across the U.S. and Florida through live, one-to-one Quran classes. Our Quran classes are designed for students of all age levels, including children, teens, adults, beginners, and advanced learners. With our experienced male and female tutors that you can choose from, students can <a style={{ color: "#006100" }} href="/quran-reading-classes-online-for-kids-and-adults/">learn Quran reading online</a>, Noorani Qaida, <a style={{ color: "#006100" }} href="/online-tajweed-classes-tajweed-course/">Tajweed course</a>, recitation, and <a style={{ color: "#006100" }} href="/quran-memorization-classes-course/">Quran memorization</a> from the comfort of their homes.
            </p>
            <p className="ny-intro-desc">
              We provide personalized Quran instruction to families across Florida, including Miami, Orlando, Tampa, Jacksonville, Fort Lauderdale, St. Petersburg, Hialeah, Tallahassee, Gainesville, Port St. Lucie, and surrounding Florida communities. Every Quran class at Al Quran Lesson is private, student-friendly, and can be joined from any location.
            </p>

            <div style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap', marginTop: '10px' }}>
              <a href="/free-trial/" className="ny-intro-btn" style={{ marginTop: 0 }}>
                Book a Free Trial Session
              </a>
              <button
                type="button"
                onClick={handleOpenChat}
                className="ny-intro-btn"
                style={{
                  marginTop: 0,
                  backgroundColor: '#ffffff',
                  color: '#006100',
                  borderColor: '#006100',
                  cursor: 'pointer',
                  fontFamily: 'inherit'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#006100';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.color = '#006100';
                }}
              >
                Talk Live With Experts
              </button>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="ny-intro-image-col">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/online-quran-classes-california/child.png`}
              alt="Learn Quran Online from the Best Online Quran Academy in Florida"
              className="ny-intro-img"
              style={{
                WebkitMaskImage: `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-canada/masking.webp')`,
                WebkitMaskSize: 'contain',
                WebkitMaskPosition: 'center',
                WebkitMaskRepeat: 'no-repeat',
                maskImage: `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-canada/masking.webp')`,
                maskSize: 'contain',
                maskPosition: 'center',
                maskRepeat: 'no-repeat'
              }}
            />
          </div>
        </div>
      </section>

      {/* Courses Offered Section */}
      <section className="ny-courses-section">
        <div className="ny-courses-container">
          <div className="ny-courses-header">
            <h2 className="ny-courses-badge">Courses Offered</h2>
            <h2 className="ny-courses-title">Online Quran Courses Available In Florida</h2>
            <div className="ny-courses-divider">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/pshape.png`}
                alt="Divider"
                className="ny-courses-divider-img"
              />
            </div>
          </div>

          <div className="ny-courses-grid">
            {/* Left Column: Image */}
            <div className="ny-courses-image-col">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/online-quran-classes-california/course-img.png`}
                alt="Online Quran Courses in Florida"
                className="ny-courses-img"
              />
            </div>

            {/* Right Column: Course list */}
            <div className="ny-courses-list">
              {/* Course 1 */}
              <a href="/quran-reading-classes-online-for-kids-and-adults/" className="ny-course-item" style={{ textDecoration: 'none' }}>
                <span className="ny-course-icon-box">
                  <svg aria-hidden="true" className="e-font-icon-svg e-fas-book-open" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"></path></svg>
                </span>
                <h3 className="ny-course-text">Quran Reading Classes Online</h3>
              </a>

              {/* Course 2 */}
              <a href="/online-tajweed-classes-tajweed-course/" className="ny-course-item" style={{ textDecoration: 'none' }}>
                <span className="ny-course-icon-box">
                  <svg aria-hidden="true" className="e-font-icon-svg e-fas-praying-hands" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg"><path d="M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"></path></svg>
                </span>
                <h3 className="ny-course-text">Quran Tajweed Classes</h3>
              </a>

              {/* Course 3 */}
              <a href="/quran-memorization-classes-course/" className="ny-course-item" style={{ textDecoration: 'none' }}>
                <span className="ny-course-icon-box">
                  <svg aria-hidden="true" className="e-font-icon-svg e-fas-mosque" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg"><path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"></path></svg>
                </span>
                <h3 className="ny-course-text">Quran Memorization Classes</h3>
              </a>

              {/* Course 4 */}
              <a href="/online-quran-translation-course/" className="ny-course-item" style={{ textDecoration: 'none' }}>
                <span className="ny-course-icon-box">
                  <svg aria-hidden="true" className="e-font-icon-svg e-fas-kaaba" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09 1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"></path></svg>
                </span>
                <h3 className="ny-course-text">Quran Translation Classes Online</h3>
              </a>
              <a href="/noorani-qaida-course/" className="ny-course-item" style={{ textDecoration: 'none' }}>
                <span className="ny-course-icon-box">
                  <svg aria-hidden="true" className="e-font-icon-svg e-fas-kaaba" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09 1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"></path></svg>
                </span>
                <h3 className="ny-course-text">Noorani Qaida Course</h3>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="ny-why-section">
        <div className="ny-why-container">
          {/* Left Column: Text & CTA */}
          <div className="ny-why-content">
            <h2 className="ny-why-title">
              Why Families Choose Al Quran Lesson As Their <span className="ny-why-title--green">Online Quran Academy In Florida?</span>
            </h2>
            <p className="ny-why-desc">
              Finding a reliable Quran teacher in Florida isn't easy. Busy school schedules, long commutes in Miami, Orlando, Tampa, or Jacksonville, and crowded group classes where children get overlooked make it hard for many families to keep Quran learning consistent. Al Quran Lesson solves this by bringing a trusted online Quran academy in Florida right to your home. You can take online Quran classes from anywhere in Florida with just a device and an internet connection. Our experienced male and female tutors teach through live one-on-one classes, giving every student personalized attention and support at their own pace. Flexible scheduling lets you choose timings that fit around school, work, and family life, and our 24/7 support team is always ready to help.
            </p>
            <p className="ny-why-desc">Not sure yet? Start with a 3-day free trial and see the difference yourself.</p>

            <a href="/free-trial/" className="ny-why-btn">
              Start Learning Quran Online in Florida, Claim Your Free Trial!
            </a>
          </div>

          {/* Right Column: Visual Stats Cards */}
          <div className="ny-why-stats-cards">
            {/* Card 1 */}
            <div className="ny-why-card-scroller">
              <div className="ny-why-card-icon-col">
                <span className="ny-why-card-icon-box">
                  <svg className="ny-why-card-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .9-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
                  </svg>
                </span>
              </div>
              <div className="ny-why-card-content-col">
                <h3 className="ny-why-card-title">13+ Years of Quran Teaching Experience</h3>
                <p className="ny-why-card-desc">With over 13 years of experience teaching the Quran online, we have helped more than 5,000 students worldwide learn Quran reading, Tajweed, and memorization.</p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="ny-why-card-scroller">
              <div className="ny-why-card-icon-col">
                <span className="ny-why-card-icon-box">
                  <svg className="ny-why-card-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                  </svg>
                </span>
              </div>
              <div className="ny-why-card-content-col">
                <h3 className="ny-why-card-title">Qualified Male and Female Quran Teachers</h3>
                <p className="ny-why-card-desc">Our team includes 20+ qualified Quran and Tajweed instructors, with male and female teachers available to provide personalized, one-on-one lessons for students of all ages.</p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="ny-why-card-scroller">
              <div className="ny-why-card-icon-col">
                <span className="ny-why-card-icon-box">
                  <svg className="ny-why-card-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm0 18c-4.41 0-8-3.59-8-8c0-.62.08-1.21.21-1.79L9 15v-2.24l-3-2.14V7.57l6-3.43l6 3.43v3.05l-3 2.14V15l4.79-3.79c.13.58.21 1.17.21 1.79c0 4.41-3.59 8-8 8z" />
                  </svg>
                </span>
              </div>
              <div className="ny-why-card-content-col">
                <h3 className="ny-why-card-title">Flexible Scheduling With a Free Trial</h3>
                <p className="ny-why-card-desc">Enjoy private lessons scheduled around your availability, making Quran learning convenient from home. Start with a 3-day free trial and experience our classes before committing. No card needed for a free trial.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Florida Reviews Section */}
      <section className="tx-reviews-section" style={{ '--tx-reviews-bg': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')` }}>
        <div className="tx-reviews-container">
          <div className="tx-reviews-header">
            <span className="tx-reviews-badge">Real Students, Real Results</span>
            <h2 className="tx-reviews-title">What Florida Families Are Saying</h2>
          </div>
          <div className="tx-reviews-grid">
            {/* Review 1 */}
            <div className="tx-review-card">
              <span className="tx-quote-icon">“</span>
              <p className="tx-review-text">
                My daughter barely knew how to read when we started. Her teacher was patient with her and explained things clearly every time. We were first recommended the Noorani Qaida, and now she is learning Tajweed.
              </p>
              <div className="tx-review-footer">
                <div className="tx-review-author">
                  <span className="tx-author-name">Sarah Muhammad</span>
                  <span className="tx-author-sub">Orlando</span>
                </div>
                <span className="tx-review-tag">4 months</span>
              </div>
            </div>

            {/* Review 2 */}
            <div className="tx-review-card">
              <span className="tx-quote-icon">“</span>
              <p className="tx-review-text">
                I wanted to work on my recitation and Tajweed without leaving the house. I was also curious about the class timing because of my daily job. Hafiz Abdullah was very helpful in every step of my admission and scheduling. I learned in depth about every Quranic verse with its meaning.
              </p>
              <div className="tx-review-footer">
                <div className="tx-review-author">
                  <span className="tx-author-name">Ahmed Raza</span>
                  <span className="tx-author-sub">Tampa</span>
                </div>
                <span className="tx-review-tag">6 months</span>
              </div>
            </div>

            {/* Review 3 */}
            <div className="tx-review-card">
              <span className="tx-quote-icon">“</span>
              <p className="tx-review-text">
                The flexible scheduling has made a real difference for us. My kids take their lessons from home, and we got to pick a female teacher, which mattered to us. We are in peace joining the Al Quran Lesson.
              </p>
              <div className="tx-review-footer">
                <div className="tx-review-author">
                  <span className="tx-author-name">Fatima Khan</span>
                  <span className="tx-author-sub">Miami</span>
                </div>
                <span className="tx-review-tag">8 months</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Free Assessment/Trial Section */}
      <section className="free-assessment" id="free-trial">
        <div className="free-assessment__container">
          {/* Left Column: Info Text */}
          <div className="free-assessment__info">
            <div className="free-assessment__subtitle">
              <svg aria-hidden="true" className="free-assessment__subtitle-icon" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
              </svg>
              <span>Apply For Free Registration</span>
            </div>

            <h2 className="free-assessment__title">
              Start Your 3-day Free Trial No Card Needed!
            </h2>

            <p className="free-assessment__description">
              During the 3-day free trial, your teacher can assess your Quran reading, pronunciation, Tajweed, and memorization level and recommend a learning plan based on your needs.
            </p>

            <ul className="free-assessment__benefits">
              <li className="free-assessment__benefit-item">
                <svg className="free-assessment__check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
                <span>Flexible Hours</span>
              </li>
              <li className="free-assessment__benefit-item">
                <svg className="free-assessment__check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
                <span>Qualified Tutors</span>
              </li>
            </ul>

            <div className="free-assessment__contacts">
              <a href="tel:+17164577657" className="free-assessment__contact-item">
                <div className="free-assessment__contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="free-assessment__contact-svg">
                    <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27 11.72 11.72 0 003.7.59 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.72 11.72 0 00.59 3.7 1 1 0 01-.27 1.11z" />
                  </svg>
                </div>
                <div className="free-assessment__contact-text">
                  <span className="free-assessment__contact-label">Call Us Anytime</span>
                  <span className="free-assessment__contact-value">(716) 457-7657</span>
                </div>
              </a>

              <a href="mailto:info@alquranlesson.com" className="free-assessment__contact-item">
                <div className="free-assessment__contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="free-assessment__contact-svg">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                </div>
                <div className="free-assessment__contact-text">
                  <span className="free-assessment__contact-label">Email Us Anytime</span>
                  <span className="free-assessment__contact-value">info@alquranlesson.com</span>
                </div>
              </a>
            </div>
          </div>

          {/* Right Column: Registration Form */}
          <div
            className="free-assessment__form-container"
            style={{
              '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')`
            }}
          >
            <form className="free-assessment__form" onSubmit={handleAssessmentSubmit}>
              <div className="free-assessment__form-row">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={assessmentData.firstName}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__input"
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={assessmentData.lastName}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__input"
                />
              </div>

              <div className="free-assessment__form-row free-assessment__form-row--full">
                <select
                  name="course"
                  value={assessmentData.course}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__select"
                >
                  <option value="" disabled>Select Course</option>
                  <option value="Noorani Qaida">Noorani Qaida</option>
                  <option value="Quran Tajweed Classes">Quran Tajweed Classes</option>
                  <option value="Quran Reading Classes">Quran Reading Classes</option>
                  <option value="Quran Memorization Classes">Quran Memorization Classes</option>
                  <option value="Quran Translation Classes">Quran Translation Classes</option>
                </select>
              </div>

              <div className="free-assessment__form-row">
                <select
                  name="country"
                  value={assessmentData.country}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__select"
                >
                  <option value="" disabled>Select Country</option>
                  <option value="USA">USA</option>
                  <option value="UK">UK</option>
                  <option value="CA">CA</option>
                  <option value="Australia">Australia</option>
                  <option value="Other">Other</option>
                </select>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone No"
                  value={assessmentData.phone}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__input"
                />
              </div>

              <div className="free-assessment__form-row free-assessment__form-row--full">
                <textarea
                  name="message"
                  placeholder="Message"
                  value={assessmentData.message}
                  onChange={handleAssessmentChange}
                  required
                  className="free-assessment__textarea"
                />
              </div>

              <button type="submit" className="free-assessment__submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Florida Benefits Intro Banner */}
      <section className="tx-benefits-intro" style={{ '--tx-benefits-bg': `url('${process.env.PUBLIC_URL}/assets/images/Hero-4.jpg')` }}>
        <div className="tx-benefits-intro__container">
          <div className="tx-benefits-intro__badge">
            <svg aria-hidden="true" className="tx-benefits-intro__badge-icon" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" fill="#005a2b" />
            </svg>
            <span>Benefits</span>
          </div>

          <h2 className="tx-benefits-intro__title">
            Benefits of Learning Quran Online With Expert Guidance Near You In Florida!
          </h2>

          <p className="tx-benefits-intro__desc">
            Learning the Quran online with Al Quran Lesson gives Florida families the quality of in-person teaching without the hassle of travel. Our qualified male and female tutors, backed by more than 13 years of teaching experience, guide students step by step, from the <a className="tx-benefits-intro__link" href="/noorani-qaida-course/">Noorani Qaida Course</a> and correct Tajweed to fluent recitation, Hifz, and understanding the meaning of the Quran. Every class is one-on-one, so your child gets full attention, instant feedback, and a pace that suits their level. Students save hours of commuting across Miami, Orlando, Tampa, or Jacksonville and learn from the comfort and safety of home.

          </p>
        </div>
      </section>



      {/* Certified Tutors Section */}
      <section className="certified-tutors" id="tutors">
        <div className="certified-tutors__container">
          {/* Headings */}
          <div className="certified-tutors__badge-wrapper">
            <span className="certified-tutors__badge">Expert Islamic Faculty</span>
          </div>
          <h2 className="certified-tutors__title">Meet Our Certified Tutors</h2>
          <p className="certified-tutors__subtitle">
            Every Tutor Is Personally Verified Certified, Experienced, And Background-Checked.
          </p>
          <div className="certified-tutors__title-underline"></div>

          {/* Content Layout */}
          <div className="certified-tutors__content">
            {/* Left Column: Features List */}
            <div className="certified-tutors__features">
              {/* Feature 1 */}
              <div className="certified-tutors__feature-item">
                <div className="certified-tutors__feature-icon-wrapper">
                  <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5.47 12.5L12 16l6.53-3.56v3.06l-6.53 3.56-6.53-3.56v-3.06z" />
                  </svg>
                </div>
                <div className="certified-tutors__feature-text">
                  <h3 className="certified-tutors__feature-title">Hifzul Quran</h3>
                  <p className="certified-tutors__feature-desc">
                    Expert tutors graduated from Islamic University.
                  </p>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="certified-tutors__feature-item">
                <div className="certified-tutors__feature-icon-wrapper">
                  <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                  </svg>
                </div>
                <div className="certified-tutors__feature-text">
                  <h3 className="certified-tutors__feature-title">Ijazah Holders</h3>
                  <p className="certified-tutors__feature-desc">
                    Authentic learning with connected Sanad.
                  </p>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="certified-tutors__feature-item">
                <div className="certified-tutors__feature-icon-wrapper">
                  <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </div>
                <div className="certified-tutors__feature-text">
                  <h3 className="certified-tutors__feature-title">Fluent English</h3>
                  <p className="certified-tutors__feature-desc">
                    Easy communication during Quran sessions.
                  </p>
                </div>
              </div>

              {/* Feature 4 */}
              <div className="certified-tutors__feature-item">
                <div className="certified-tutors__feature-icon-wrapper">
                  <svg className="certified-tutors__feature-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2c-4.97 0-9 4.03-9 9 0 2.12.74 4.07 1.97 5.61L4.35 19.4c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l2.79-2.79C10.09 18.66 11.02 19 12 19c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 15c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z" />
                  </svg>
                </div>
                <div className="certified-tutors__feature-text">
                  <h3 className="certified-tutors__feature-title">Kids Specialists</h3>
                  <p className="certified-tutors__feature-desc">
                    Fun and patient teaching style for kids.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column: Swiper Carousel Slider */}
            <div className="certified-tutors__slider-container">
              <Swiper
                modules={[Pagination]}
                spaceBetween={30}
                grabCursor={true}
                pagination={{
                  clickable: true,
                  bulletClass: 'certified-tutors__pagination-bullet',
                  bulletActiveClass: 'certified-tutors__pagination-bullet--active'
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1.2,
                    spaceBetween: 20
                  },
                  576: {
                    slidesPerView: 1.8,
                    spaceBetween: 20
                  },
                  991: {
                    slidesPerView: 2.5,
                    spaceBetween: 30
                  }
                }}
                className="certified-tutors__swiper"
              >
                {tutorsData.map((tutor, index) => (
                  <SwiperSlide key={index}>
                    <div className="certified-tutors__card">
                      <div className="certified-tutors__card-image-wrapper">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/images/${tutor.image}`}
                          alt={tutor.name}
                          className="certified-tutors__card-img"
                        />
                      </div>
                      <div className="certified-tutors__card-content">
                        <h3 className="certified-tutors__card-name">{tutor.name}</h3>
                        <span className="certified-tutors__card-role">{tutor.role}</span>
                        <p className="certified-tutors__card-desc">{tutor.description}</p>
                        <a href={tutor.profileUrl} className="certified-tutors__card-btn">
                          View Profile
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      {/* Florida CTA Trial Section */}
      <section className="tx-cta-trial" style={{ '--tx-cta-bg': `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')` }}>
        <div className="tx-cta-trial__container">
          {/* Left Column: Content */}
          <div className="tx-cta-trial__content">
            <h2 className="tx-cta-trial__title">
              Ready to Start Learning Quran? Claim Your 3-Day Free Trial Today!
            </h2>
            <div className="tx-cta-trial__underline"></div>
            <a href="/free-trial/" className="tx-cta-trial__btn">
              Book Your 3-Day Free Trial &rarr;
            </a>
          </div>

          {/* Right Column: Image */}
          <div className="tx-cta-trial__image-col">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/online-quran-classes-california/Img-.png`}
              alt="Get 3 Days Free Trial & Start Learning Online Quran With Tajweed!"
              className="tx-cta-trial__img"
            />
          </div>
        </div>
      </section>

      {/* Florida How It Works Section */}
      <div
        className="tx-how-it-works-wrapper"
        style={{
          '--bg-parallax': `url('${process.env.PUBLIC_URL}/assets/images/Hero-4.jpg')`
        }}
      >
        <section className="parallax-section how-it-works" id="how-it-works">
          <div className="parallax-section__container">
            <div className="how-it-works__badge">HOW IT WORKS</div>

            <h2 className="how-it-works__title">
              3-Step Online Quran Learning Process
            </h2>

            <div className="how-it-works__steps-container">
              {/* Step 1 */}
              <div className="how-it-works__step">
                <div className="how-it-works__icon-wrapper">
                  <svg className="how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                  </svg>
                </div>
                <h3 className="how-it-works__step-num">Choose Your Quran Course</h3>
                <p className="how-it-works__step-desc">
                  Select the Quran course that matches your learning goals, whether you are a beginner, want to improve Tajweed, or plan to memorize the Quran.
                </p>
              </div>

              {/* Step 2 */}
              <div className="how-it-works__step">
                <div className="how-it-works__icon-wrapper">
                  <svg className="how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <h3 className="how-it-works__step-num">Meet Your Quran Teacher</h3>
                <p className="how-it-works__step-desc">
                  Get matched with a qualified male or female Quran teacher for personalized, one-on-one online lessons based on your needs and learning level.
                </p>
              </div>

              {/* Step 3 */}
              <div className="how-it-works__step">
                <div className="how-it-works__icon-wrapper">
                  <svg className="how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </div>
                <h3 className="how-it-works__step-num">Start Learning With a Free Trial</h3>
                <p className="how-it-works__step-desc">
                  Begin your Quran lessons from home with a 3-day free trial. Enjoy flexible scheduling and continue your classes according to your availability
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* FAQs Section */}
      <section className="faq-section" id="faq">
        <div className="faq-section__container">
          <div className="faq-section__grid">
            {/* Left Column: Heading and Left Accordion FAQs */}
            <div className="faq-section__col faq-section__col--left">
              <h2 className="faq-section__title">Frequently Asked Questions About Online Quran Classes In Florida</h2>
              <p className="faq-section__subtitle" style={{ fontSize: '15.5px', lineHeight: '1.7', color: '#555555', marginBottom: '32px' }}>
                Have questions about learning the Quran online in Florida? Find answers to common questions about online Quran classes, course options, class schedules, qualified tutors, learning for kids and adults, and how to get started with a convenient 3-day free trial.
              </p>


              <div className="faq-section__accordion">
                {FloridaLeftFAQs.map((faq) => (
                  <div key={faq.id} className={`faq-item ${openFaqId === faq.id ? 'faq-item--open' : ''}`}>
                    <button
                      className="faq-item__header"
                      onClick={() => toggleFloridaFAQ(faq.id)}
                      aria-expanded={openFaqId === faq.id}
                    >
                      <span>{faq.question}</span>
                      <svg className="faq-item__icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <div className="faq-item__body">
                      <div className="faq-item__content">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column: Right Accordion FAQs */}
            <div className="faq-section__col faq-section__col--right">
              <div className="faq-section__accordion">
                {FloridaRightFAQs.map((faq) => (
                  <div key={faq.id} className={`faq-item ${openFaqId === faq.id ? 'faq-item--open' : ''}`}>
                    <button
                      className="faq-item__header"
                      onClick={() => toggleFloridaFAQ(faq.id)}
                      aria-expanded={openFaqId === faq.id}
                    >
                      <span>{faq.question}</span>
                      <svg className="faq-item__icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <div className="faq-item__body">
                      <div className="faq-item__content">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Calendly Consultation & Contact Info Section */}
      <section
        className="consultation-section"
        id="consultation"
        style={{
          '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-california/edb9b1a643ea3ab6044ffcbbb4fe0032.png')`
        }}
      >
        <div className="consultation-section__container">
          {/* Header Block */}
          <div className="consultation-section__header">
            <h2 className="consultation-section__title">
              Claim Your Free 3-Day Quran Trial Today!
            </h2>
            <div className="consultation-section__subtitle">
              At our online Quran academy in Florida, we teach students of all ages and levels, from someone opening the Quran for the very first time to advanced students refining their recitation.
              We teach every student across Florida, including Miami, Orlando, Tampa, Jacksonville, Fort Lauderdale, Tallahassee, Gainesville, Cape Coral, and St. Petersburg.
            </div>
          </div>

          {/* Content Columns */}
          <div className="consultation-section__grid">
            {/* Left Column: Calendly widget */}
            <div className="consultation-section__widget-container">
              <div
                className="calendly-inline-widget"
                data-url="https://calendly.com/alquranlesson/call-consultation"
                style={{ minWidth: '320px', height: '700px' }}
              />
            </div>

            {/* Right Column: Contact Info list */}
            <div className="consultation-section__info">
              <h3 className="consultation-section__info-title">CONTACT INFO</h3>

              <ul className="consultation-section__list">
                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <a href="https://maps.google.com/?q=Mississauga,+Ontario,+L5K,+1W2" target="_blank" rel="noopener noreferrer" className="consultation-section__link">
                    Mississauga, Ontario, L5K, 1W2
                  </a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <a href="https://maps.google.com/?q=1942+BROADWAY+ST+STE+314C,+80302,+BOULDER,+United+States" target="_blank" rel="noopener noreferrer" className="consultation-section__link">
                    1942 BROADWAY ST STE 314C, 80302, BOULDER, United States
                  </a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a href="tel:+16477385707" className="consultation-section__link">+1 647 738 5707 (Canada)</a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper consultation-section__icon-wrapper--whatsapp">
                    <FaWhatsapp className="consultation-section__icon" />
                  </div>
                  <a href="https://wa.me/17164577657" target="_blank" rel="noopener noreferrer" className="consultation-section__link">716-457-7657</a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a href="tel:+17164577657" className="consultation-section__link">+1 716 457 7657 (USA)</a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a href="tel:+447441394281" className="consultation-section__link">+44 7441 394281 (UK)</a>
                </li>

                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <a href="mailto:info@alquranlesson.com" className="consultation-section__link">info@alquranlesson.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OnlineQuranClassesFlorida;

